// extracted by mini-css-extract-plugin
module.exports = {"page":"BioTriples_page__3NzIO","question_body":"BioTriples_question_body__3tJ2D","answers":"BioTriples_answers__1hAy4","title_column":"BioTriples_title_column__Sqfil"};